"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFactContentProperty = exports.factContentPropertyDefinition = void 0;
exports.factContentPropertyDefinition = {
    view: { label: 'Fact' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['fact-content-label', 'fact-content-text'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'fact-content',
};
const isFactContentProperty = (prop) => {
    return prop.name === exports.factContentPropertyDefinition.name;
};
exports.isFactContentProperty = isFactContentProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdC1jb250ZW50LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZmFjdC1jb250ZW50LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRTtJQUN2QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFLENBQUMsb0JBQW9CLEVBQUUsbUJBQW1CLENBQUM7U0FDdEQ7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsY0FBYztDQUNXLENBQUE7QUFJMUIsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLElBQWtCLEVBQStCLEVBQUU7SUFDdkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFDQUE2QixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakMifQ==